/** Extract a human-readable message from an unknown axios error, or a plain Error thrown client-side. */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: { error?: string } } };
  if (e?.response?.data?.error) return e.response.data.error;
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
